module.exports = __webpack_public_path__ + "static/media/mailIcon.db8bc715.svg";